const SchoolsAndEducationalServicesIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.75 9V17.25C18.75 17.25 14.361 18.75 12 18.75C9.639 18.75 5.25 17.25 5.25 17.25V9M21 7.5L12 3.75L3 7.5L12 12L21 7.5ZM21 7.5V14.25"
      stroke="black" strokeWidth="0.5"/>
  </svg>
);

export default SchoolsAndEducationalServicesIcon;
